import ModalComponent from '../../../components/ModalComponent';

const Index = (props:Props) => {
  const {
    open, handleClose, handleSave, blockTitle,
  } = props;

  return (
    <ModalComponent
      title="ブロック削除"
      confirmButtonText="削除"
      confirmButtonColor="danger"
      onConfirm={handleSave}
      show={open}
      closeModal={handleClose}
      centered
      animation={false}
    >
      <p className="mb-0">
        ブロック「
        {blockTitle}
        」を削除してもよろしいですか？
      </p>
    </ModalComponent>
  );
};

interface Props {
  open: boolean
  blockTitle: string
  handleClose: () => void
  handleSave: () => void
}

export default Index;
